export default __webpack_public_path__ + "static/media/quiz_people.4068d878.png";